import { render } from "./CkEditorField.vue?vue&type=template&id=95ff5f86"
import script from "./CkEditorField.vue?vue&type=script&lang=js"
export * from "./CkEditorField.vue?vue&type=script&lang=js"

import "./CkEditorField.vue?vue&type=style&index=0&id=95ff5f86&lang=css"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CkEditorField.vue"]])

export default __exports__